/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { ValuesOf } from '@tmapy/beetlejuice-utils';

/**
 * ```yaml
 * type: integer
 * ```
 */
export const Roles = {
  ADMIN: 'ADMIN',
  MANAGER_EDITOR: 'MANAGER_EDITOR',
  MANAGER_MANAGER: 'MANAGER_MANAGER',
  MANAGER_SUPERVISOR: 'MANAGER_SUPERVISOR',
  PREJIMKA_RECEIVER: 'PREJIMKA_RECEIVER',
  PREJIMKA_USER: 'PREJIMKA_USER',
  Spravce_DTI_DMVS: 'Spravce_DTI_DMVS',
  Spravce_dat_DI: 'Spravce_dat_DI',
  Spravce_dat_TI: 'Spravce_dat_TI',
  VYDEJ_APPROVER: 'VYDEJ_APPROVER',
  VYDEJ_KRAJ: 'VYDEJ_KRAJ',
  VYDEJ_MANAGER: 'VYDEJ_MANAGER',
  VYDEJ_ORP: 'VYDEJ_ORP',
  VYDEJ_USER: 'VYDEJ_USER',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type Roles = ValuesOf<typeof Roles>;

export type RolesRequest = Roles;
export type RolesResponse = Roles;
